import { useBoxIsHovered as s } from "./index.es522.js";
function t(r) {
  let e = r;
  if (s())
    switch (r) {
      case "gray":
        e = "primary";
        break;
      case "success":
        e = "success-hover";
        break;
      default:
        e = r;
    }
  return e;
}
export {
  t as useHoveredTextColorTransformer
};
//# sourceMappingURL=index.es800.js.map
